import { render, staticRenderFns } from "./AboutComponent.vue?vue&type=template&id=4243f35f&scoped=true&"
import script from "./AboutComponent.vue?vue&type=script&lang=js&"
export * from "./AboutComponent.vue?vue&type=script&lang=js&"
import style0 from "./AboutComponent.vue?vue&type=style&index=0&id=4243f35f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4243f35f",
  null
  
)

export default component.exports